import apiClient from "./client";

export const kvkkPolicy = {
  getByToken: () => apiClient.get("/policies/kvkk-metni"),
};
